import { Button, Dialog, Icon } from '@risksmart-app/atomic-ui';
import { Trans, useTranslation } from 'react-i18next';

interface SaveDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onUpdate: () => void;
  onInsert: () => void;
  isSaving: boolean;
  requiresNewVersion: boolean;
}

export const SaveDialog = ({
  open,
  onOpenChange,
  onUpdate,
  onInsert,
  isSaving,
  requiresNewVersion,
}: SaveDialogProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'riskScoringSettings',
  });

  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        if (!isSaving) {
          onOpenChange(open);
        }
      }}
      size={'md'}
    >
      <Dialog.Header
        title={
          requiresNewVersion ? t('save.newVersionTitle') : t('save.updateTitle')
        }
      />
      <Dialog.Body>
        <Trans
          i18nKey={
            requiresNewVersion
              ? 'riskScoringSettings.save.newVersionBody'
              : 'riskScoringSettings.save.updateBody'
          }
          ns={'common'}
          components={{ bold: <span className={'font-bold'} /> }}
        />
      </Dialog.Body>
      <Dialog.Footer>
        <Button onClick={onInsert} disabled={isSaving}>
          <Icon name={'save-01'} />
          {isSaving ? t('save.saving') : t('save.saveAsNew')}
        </Button>
        {!requiresNewVersion && (
          <Button
            onClick={onUpdate}
            disabled={isSaving}
            variant={'neutral'}
            style={'outline'}
          >
            <Icon name={'refresh-02'} />
            {isSaving ? t('save.updating') : t('save.update')}
          </Button>
        )}
        <Dialog.Close
          render={
            <Button variant={'neutral'} style={'outline'} disabled={isSaving}>
              {t('cancel')}
            </Button>
          }
        />
      </Dialog.Footer>
    </Dialog>
  );
};
